'use client'

import { type PointerEvent } from 'react'

import { FiltersPanel } from '@/components/common/FiltersPanel'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'

import { SidebarRoot } from '../SidebarRoot/SidebarRoot'

export const SidebarFilters = () => {
  const dispatch = useReduxDispatch()
  const status = useReduxSelector((s) => s.view.filtersStatus)

  const onClick = () => dispatch(viewActions.expandFilters())
  const onClickClose = () => dispatch(viewActions.collapseFilters())
  const onClickLock = () => dispatch(viewActions.toggleFiltersLock())

  const onPointerLeave = (e: PointerEvent<HTMLElement>) => {
    if (e.pointerType === 'mouse') dispatch(viewActions.unhoverFilters())
  }

  return (
    <SidebarRoot
      onClick={onClick}
      onClickClose={onClickClose}
      onClickLock={onClickLock}
      onPointerLeave={onPointerLeave}
      position='left'
      sidebar='filters'
      status={status}
      title='Filters'
    >
      <FiltersPanel />
    </SidebarRoot>
  )
}
